import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const navigate = useNavigate();
  return (
    <section className="section">
      <div className="container">
        <div className="cta-card">
          <div className="section-eyebrow">GET STARTED</div>
          <h2>
            Ready to <span className="text-gradient">Start Mining?</span>
          </h2>
          <p>
            Connect your wallet, choose a package, and start earning XT Tokens today —
            all on a transparent, community-driven platform.
          </p>
          <button className="btn btn-primary btn-lg pulse-glow" onClick={() => navigate('/dashboard')}>
            Start Mining →
          </button>
        </div>
      </div>
    </section>
  );
}
